<script setup>
import dayjs from "dayjs/esm";
import { onMounted, ref } from "vue";
import { useQuasar } from "quasar";
import { toDate, sessionFormat, sessionParse } from "@/filters";
import { fetchWithHeaders } from "@/utils";
import { useRouter } from "vue-router";

const router = useRouter();
const $q = useQuasar();
const sessions = ref([]);
onMounted(async () => {
    const url = `${window._env_.API_ENDPOINT}/sessions/`;
    sessions.value = await fetchWithHeaders(url);
});

function createSession() {
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();
    if (month < 6) {
        month = "06";
    } else if (month < 8) {
        month = "08";
    } else {
        year = dayjs().add(1, "year").year();
        month = "01";
    }
    $q.dialog({
        title: "Créer une session",
        message: "Code de la session?",
        prompt: {
            model: `${month}/${year}`,
            mask: "##/####",
            isValid: val => val.length === 7,
            type: "text",
        },
        cancel: true,
        persistent: true,
    }).onOk(data => {
        const code = sessionParse(data);
        const url = `${window._env_.API_ENDPOINT}/sessions/`;
        fetchWithHeaders(url, {
            method: "POST",
            body: JSON.stringify({ code }),
        }).then(session => {
            router.push(`/admin/session/${session.code}/slots`);
        });
    });
}
</script>
<template>
    <main>
        <q-card class="q-pa-md q-mt-lg q-mx-auto">
            <div class="q-mb-lg row items-start">
                <div class="text-h3">Sessions</div>
                <q-space />
                <q-btn label="ajouter" color="primary" outline="" icon="fa-solid fa-plus" @click="createSession" />
            </div>
            <q-list>
                <template v-for="session in sessions" :key="session.code">
                    <q-item v-ripple class="q-my-sm" clickable :to="`/admin/session/${session.code}`">
                        <q-item-section avatar>
                            <q-icon
                                :color="session.state == 'C' ? 'negative' : 'positive'"
                                :name="session.state == 'C' ? 'fa-solid fa-lock' : 'fa-solid fa-lock-open'"
                            />
                        </q-item-section>

                        <q-item-section top>
                            <q-item-label
                                ><span class="text-h5 q-pr-lg">{{ sessionFormat(session.code) }}</span>
                                {{ toDate(session.open_date) }} - {{ toDate(session.close_date) }}</q-item-label
                            >
                            <q-item-label caption lines="1"
                                >Inscriptions {{ session.registrations_count }} / {{ session.seats_total || 0 }} places
                                dans {{ session.slots_count }} créneaux. Places libres {{ session.seats_free || 0 }}
                            </q-item-label>
                        </q-item-section>

                        <q-item-section side>
                            <div>
                                <q-btn
                                    flat
                                    color="primary"
                                    icon="fa-solid fa-calendar-plus"
                                    label="Edition"
                                    :to="`/admin/session/${session.code}/slots`"
                                    @click.stop
                                ></q-btn>
                                <q-btn
                                    flat
                                    color="info"
                                    icon="fa-solid fa-table-list"
                                    label="Mutations"
                                    :to="`/admin/session/${session.code}/mutations`"
                                    @click.stop
                                ></q-btn>
                                <q-btn
                                    flat
                                    color="positive"
                                    icon="far fa-file-excel"
                                    label="Rapport Statistique"
                                    :disable="session.state == 'C' && toDate(session.close_date) < toDate(new Date())"
                                    :to="`/admin/error/not-implemented`"
                                    @click.stop
                                ></q-btn>
                            </div>
                        </q-item-section>
                    </q-item>
                    <q-separator />
                </template>
            </q-list>
        </q-card>
    </main>
</template>
